import { def } from "../../../config";
import fetchServer from "../../fetchServer";

export default async function removeWhitelistDomain(authAdmin, origin) {
  let result = { return: 0, msg: "Something went wrong fetching members!" };

  await fetchServer({
    method: "DELETE",
    url: `/setting/deleteCors?authorizationCode=${authAdmin}&origin=${origin}`,
    api: def.api?.replace("/api", ""),
  })
    .then((res) => {
      console.log(" => ", res);
      if (res?.status === 200) {
        result = {
          return: 1,
          msg: "Successfull",
          data: res?.data?.allowedOrigins || [],
        };
      } else if (res?.data?.error) result["msg"] = res.data.error;
    })
    .catch((err) => {
      console.log("Network Error!");
    });

  return result;
}
